import React, { useEffect } from 'react';
import './BackgroundElement.css';

const BackgroundElement = ({ element, isPreviewMode, onUpdate }) => {
  const backgroundType = element.backgroundType || 'color';
  const backgroundColor = element.style?.backgroundColor || '#ffffff';
  const backgroundImage = element.style?.backgroundImage || '';

  // Apply background to canvas
  useEffect(() => {
    // Find the canvas element
    const canvas = document.querySelector('.canvas');
    if (!canvas) return;
    
    // Apply background
    if (backgroundType === 'color') {
      canvas.style.backgroundColor = backgroundColor;
      canvas.style.backgroundImage = '';
    } else if (backgroundType === 'image' && backgroundImage) {
      canvas.style.backgroundImage = `url(${backgroundImage})`;
      canvas.style.backgroundSize = 'cover';
      canvas.style.backgroundPosition = 'center';
      canvas.style.backgroundRepeat = 'no-repeat';
    }
    
    // Don't provide a cleanup function since we want the background
    // to persist even when the component unmounts
    // This ensures the background stays visible in preview and published modes
  }, [backgroundType, backgroundColor, backgroundImage, element.id]);

  // In preview mode, don't render the visible UI, but still keep a placeholder element
  // to ensure the component remains in the DOM and its useEffect still applies
  if (isPreviewMode) {
    return <div className="background-element background-element-preview" style={{ display: 'none' }} />;
  }

  // In edit mode, show a simple placeholder
  return (
    <div className="background-element-placeholder">
      <div className="background-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" stroke="#666" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="1.5" />
          <path d="M3 16L7 12L10 15L17 8L21 12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <div className="background-element-text">
        <div className="background-title">Background Element</div>
        <div className="background-description">
          {backgroundType === 'color' ? 
            `Color: ${backgroundColor}` : 
            'Image Background'}
        </div>
        <div className="background-info">Edit properties in the panel →</div>
      </div>
    </div>
  );
};

export default BackgroundElement; 